import { __decorate } from "tslib";
import { html, LitElement } from 'lit';
import { property, queryAssignedNodes } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import accordionItemContentStyles from './accordion-content.scss.js';
import styles from './accordion-item.scss.js';
/**
 * cipublic-accordion-item
 *
 * @slot heading
 * @slot headingSummary
 * @slot content
 */
export class AccordionItem extends LitElement {
    constructor() {
        super(...arguments);
        this.headerlevel = '4';
        this.expanded = false;
        this.emitConnectedCallback = false;
    }
    static get styles() {
        return [styles];
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.emitConnectedCallback) {
            emit(this, 'connected-callback');
        }
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        if (changedProperties.has('hash')) {
            if (window.location.hash.split('#')[1] === this.hash) {
                this.setAttribute('open', '');
            }
        }
    }
    async updated() {
        await this.updateComplete;
        const accordionItemContent = this.querySelector('[slot="content"]');
        addStyleSheetToElements([accordionItemContent], accordionItemContentStyles);
    }
    render() {
        let headertag;
        switch (this.headerlevel) {
            case '1':
                headertag = html `<h1 class="heading"><button class="accordion-header-button" aria-expanded="${this.expanded}" aindex="${this.aindex}"><slot name="heading"></slot></button></h1>`;
                break;
            case '2':
                headertag = html `<h2 class="heading"><button class="accordion-header-button" aria-expanded="${this.expanded}" aindex="${this.aindex}"><slot name="heading"></slot></button></h2>`;
                break;
            case '3':
                headertag = html `<h3 class="heading"><button class="accordion-header-button" aria-expanded="${this.expanded}" aindex="${this.aindex}"><slot name="heading"></slot></button></h3>`;
                break;
            case '4':
                headertag = html `<h4 class="heading"><button class="accordion-header-button" aria-expanded="${this.expanded}" aindex="${this.aindex}"><slot name="heading"></slot></button></h4>`;
                break;
            case '5':
                headertag = html `<h5 class="heading"><button class="accordion-header-button" aria-expanded="${this.expanded}" aindex="${this.aindex}"><slot name="heading"></slot></button></h5>`;
                break;
            case '6':
                headertag = html `<h6 class="heading"><button class="accordion-header-button" aria-expanded="${this.expanded}" aindex="${this.aindex}"><slot name="heading"></slot></button></h6>`;
                break;
        }
        if (this.variant === 'fullWidth') {
            return html `<div class="${this.variant}-accordion accordion-button" showText="${ifDefined(this.showText)}" hideText="${ifDefined(this.hideText)}" @click="${this.clickevent}"><div class="fullwidth-button-container"><div class="button-grid"><cipublic-icon class="icon" set="system" name="caret-right"></cipublic-icon>${headertag}</div><slot name="headingSummary" class="headingSummary"></slot></div></div><slot name="content" class="content"></slot>`;
        }
        return html `<div class="${this.variant}-accordion accordion-button" showText="${ifDefined(this.showText)}" hideText="${ifDefined(this.hideText)}" @click="${this.clickevent}"><cipublic-icon class="icon" set="system" name="caret-right"></cipublic-icon>${headertag}</div><slot name="content" class="content"></slot>`;
    }
    clickevent() {
        var _a;
        if ((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.accordion-header-button')) {
            const accordion = this.shadowRoot.querySelector('.accordion-header-button');
            let isopen;
            if ((accordion === null || accordion === void 0 ? void 0 : accordion.getAttribute('aria-expanded')) === 'true') {
                isopen = 'true';
            }
            else {
                isopen = 'false';
            }
            const accordionEvent = new CustomEvent('accordionToggle', {
                detail: {
                    aindex: `${accordion === null || accordion === void 0 ? void 0 : accordion.getAttribute('aindex')}`,
                    open: `${isopen}`,
                },
                bubbles: true,
                composed: true,
            });
            this.dispatchEvent(accordionEvent);
        }
    }
}
__decorate([
    property({ type: String, reflect: true })
], AccordionItem.prototype, "variant", void 0);
__decorate([
    property({ type: String, reflect: true })
], AccordionItem.prototype, "showText", void 0);
__decorate([
    property({ type: String, reflect: true })
], AccordionItem.prototype, "headerlevel", void 0);
__decorate([
    property({ type: String, reflect: true })
], AccordionItem.prototype, "hideText", void 0);
__decorate([
    property({ type: String, reflect: true })
], AccordionItem.prototype, "aindex", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], AccordionItem.prototype, "expanded", void 0);
__decorate([
    property({ type: String, reflect: true })
], AccordionItem.prototype, "hash", void 0);
__decorate([
    queryAssignedNodes('heading', true)
], AccordionItem.prototype, "accordionInlineHeading", void 0);
__decorate([
    property({ reflect: true, type: Boolean })
], AccordionItem.prototype, "emitConnectedCallback", void 0);
//# sourceMappingURL=accordion-item.js.map